import { Fallback } from '@/views/fallback'
import { MainLayout, Container } from '@football-australia/ui-core'

export const Root = () => {
  return (
    <MainLayout>
      <Container fullWidth fullHeight align="center" justify="center">
        <Fallback />
      </Container>
    </MainLayout>
  )
}
